import { PASSWORD_RULES } from "../api/emailAuthApi";
import "../styles/AuthPages.css";
import { BRAND } from "../../../branding";

export function AuthLayout({ eyebrow, title, subtitle, children, footer }) {
  return (
    <div className="auth-root">
      <aside className="auth-brand" aria-hidden="true">
        {BRAND.orgName && <div className="auth-brand__mark">{BRAND.orgName}</div>}
        <div className="auth-brand__name">{BRAND.productName}</div>
        <p className="auth-brand__tag">Tasks, defects, effort and delivery, in one place.</p>
        {BRAND.orgWebsite && <div className="auth-brand__meta">{BRAND.orgWebsite}</div>}
      </aside>
      <main className="auth-main">
        <div className="auth-card">
          <div className="auth-card__mobile-brand">{BRAND.orgName && <>{BRAND.orgName} </>}<span>{BRAND.productName}</span></div>
          {eyebrow && <div className="auth-eyebrow">{eyebrow}</div>}
          <h1 className="auth-title">{title}</h1>
          {subtitle && <p className="auth-subtitle">{subtitle}</p>}
          {children}
        </div>
        {footer && <div className="auth-footer">{footer}</div>}
      </main>
    </div>
  );
}

export function AuthField({ label, hint, children }) {
  return (
    <label className="auth-field">
      <span className="auth-field__label">{label}</span>
      {children}
      {hint && <span className="auth-field__hint">{hint}</span>}
    </label>
  );
}

export function AuthError({ message }) {
  if (!message) return null;
  return <div className="auth-alert auth-alert--error" role="alert">{message}</div>;
}

export function AuthNotice({ children }) {
  return <div className="auth-alert auth-alert--info" role="status">{children}</div>;
}

export function PasswordChecklist({ password, confirm, showMatch = true }) {
  const pw = password || "";
  return (
    <ul className="auth-checklist">
      {PASSWORD_RULES.map((r) => {
        const ok = r.test(pw);
        return (
          <li key={r.key} className={ok ? "is-ok" : ""}>
            <span className="auth-checklist__dot" aria-hidden="true">{ok ? "✓" : ""}</span>
            {r.label}
          </li>
        );
      })}
      {showMatch && (
        <li className={pw && pw === confirm ? "is-ok" : ""}>
          <span className="auth-checklist__dot" aria-hidden="true">{pw && pw === confirm ? "✓" : ""}</span>
          Passwords match
        </li>
      )}
    </ul>
  );
}

export function CodeInput({ value, onChange, autoFocus = true }) {
  return (
    <input
      className="auth-input auth-input--code"
      inputMode="numeric"
      autoComplete="one-time-code"
      pattern="[0-9]*"
      maxLength={6}
      placeholder="000000"
      value={value}
      autoFocus={autoFocus}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 6))}
      aria-label="6-digit authentication code"
    />
  );
}
